/**
 * bem helper
 * b() // 'button'
 * b('text') // 'text' 对应的css .button .text
 * b({ disabled }) // 'button button-disabled'
 * b('text', { disabled }) // 'text text-disabled'
 * b(['disabled', 'primary']) // 'button button-disabled button-primary'
 */

const ELEMENT = '__';
const MODS = '-';

const join = (name, el, symbol) => el ? name + symbol + el : name;

const prefix = (name, mods) => {
  if (typeof mods === 'string') {
    return join(name, mods, MODS);
  }

  if (Array.isArray(mods)) {
    return mods.map(item => prefix(name, item));
  }

  const ret = {};
  Object.keys(mods).forEach(key => {
    ret[name + MODS + key] = mods[key];
  });
  return ret;
};

const parse = (name, mods) => {
  if (typeof mods === 'string') {
    return mods;
  }

  if (Array.isArray(mods)) {
    return mods.map(item => parse(name, item))
  }

  const ret = {};
  Object.keys(mods).forEach(key => {
    ret[key] = mods[key];
  });
  return ret;
};

export default {
  methods: {
    b(el, mods) {
      const { name } = this.$options;
      // let subName = name.substr(3) //trim om-
      if (!el) {
        el = name;
      }
      else if (el && typeof el !== 'string') {
        mods = el;
        el = name;
      }
      // el = join(name, el, ELEMENT);
      return mods ? [el, prefix(el, mods)] : el;
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/mixins/bem.js